import styled from 'styled-components'

export const AccountStepWrapper = styled.div`
  overflow: scroll;
  width: 100% !important;
  padding: 0 25%;

  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  button {
    margin: 0 auto;
  }

  .container-buttons {
    button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 392px;
      background: ${({ theme }) => theme.colors.primary};
    }

    button + button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 392px;
      margin-top: ${({ theme }) => theme.spacings[2]};
      background: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`
export const InstitutionName = styled.label`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.arial};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.25px;
  text-align: left;
  padding-bottom: 20px;
  display: flex;
`
